/* ------------------------------------------------------------------
ストーリーのいいね・応援についての状態を取得する
--------------------------------------------------------------------- */
const initializeStoryInfo = (routes) => {
  initializeStoryCount(routes);
  initializeStoryLikeBtn(routes);
  initializeStorySupportBtn(routes);
};

// ストーリーのいいね数・応援数取得
const initializeStoryCount = (routes) => {
  if (document.querySelector(".jsStoryLikeSupportCount")) {
    const displayed_story_ids = $(".jsStoryCount, .jsStoryCountWithIcon")
      .map((i, elm) => $(elm).data("id"))
      .get();
    $.ajax({
      url: routes.async_info_stories_path({ ids: displayed_story_ids }),
      type: "GET",
      dataType: "json",
      success(data) {
        data.stories.forEach((story) => {
          $(`.jsStoryCount[data-id=${story.id}]`).text(
            story.likes_count + story.supports_count
          );
          $(`.jsStoryCountWithIcon[data-id=${story.id}]`).text(
            story.supports_likes_count_exclude_displayed_icon
          );
        });
        initializeRecomendPostStory(data);
      },
      error(_XMLHttpRequest, _textStatus, _errorThrown) {
        console.log("error");
      },
    });
  }
};

// いいねボタン、いいね済みの場合はデザイン変更
const initializeStoryLikeBtn = (routes) => {
  if (document.querySelector(".jsStoryLike")) {
    $.ajax({
      url: routes.async_info_story_like_path(),
      type: "GET",
      dataType: "json",
      success(data) {
        data.liking_ids.forEach((story_id) => {
          $(`.jsStoryLike[data-id=${story_id}]`).addClass("isAdded");
        });
      },
      error(_XMLHttpRequest, _textStatus, _errorThrown) {
        console.log("error");
      },
    });
  }
};

// 応援ボタン、応援済みの場合は「応援済み」に変更
const initializeStorySupportBtn = (routes) => {
  if (document.querySelector(".jsStorySupport")) {
    $.ajax({
      url: routes.async_info_story_support_path(),
      type: "GET",
      dataType: "json",
      success(data) {
        data.supporting_ids.forEach((story_id) => {
          $(`.jsStorySupport[data-id=${story_id}]`).addClass("isAdded");
        });
      },
      error(_XMLHttpRequest, _textStatus, _errorThrown) {
        console.log("error");
      },
    });
  }
};

// 投稿してみませんか?ボタンを追加
const initializeRecomendPostStory = (data) => {
  if (document.querySelector("#jsRecomendPostStory")) {
    if (data.recomend_btn_html) {
      $("#jsRecomendPostStory").html(data.recomend_btn_html);
    }
  }
};

// NOTE: esbuild IIFE バンドルではモジュールスコープが分離されるため、グローバルに公開する

export default initializeStoryInfo;
